import { RouteComponentProps, withRouter } from 'react-router-dom';
import { OfficialDetailVm } from '../../../../utils/api';
import { RouteParams } from '../../../../core/models/RouteHelper';
import OfficialDetails from './OfficialDetails';
import { Profile } from 'oidc-client';

interface OwnProps {
    userProfile: Profile;
    isInitialEdit: boolean;
    official: OfficialDetailVm;
    refreshAfterSave: () => Promise<void>;
}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(OfficialDetails);
